"use client"

import { VolumeOff } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `VolumeOffIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const VolumeOffIcon = component(Icon)({ as: VolumeOff })
